// extracted by mini-css-extract-plugin
export var chevronIcon = "_da-2";
export var teamName = "_da-1";
export var teamSwitcherButton = "_da-0";